
import React from "react";
import { connect } from "react-redux";
import DynamicMainScreen from "../../components/dynamicscreens/DynamicMainScreen";
import endpoint from "../../config/endpoints";
import { MyClaimColumns } from "../../tableColumns/table-columns";
import { MyClaimJson } from "../../DynamicFormsJson/MastersJSON/myClaim";
import { getClaimBalanceAndHistory } from "../../Slice/claim.slice";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import dayjs from "dayjs";
import {
  cancelBillMsg,
  cancelClaim,
  changeActive,
  noInternetMsg,
  savemsg,
  serverMsg,
  statusmsg,
} from "../../config/messageconstant";
import { apiGet } from "../../utils/api_service";
import { Paper } from "@mui/material";
import MyClaimViewPopUp from "./MyClaimViewPopUp";
import { getClaimDetailsForDayEndBeats } from "../../Slice/beat.slice";

class MyClaimTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      claimDetailsData: {},
      viewPopup: false,
      viewData: {},
      claimApplyDetails: [],
      DataToSet: [],
      fixedCalculation: "",
      dataList: [],
    };
  }

  async componentDidMount() {
    await this.getData();
  }


  getData = async () => {
    const { getClaimBalanceAndHistory, showLoador, showNotification } =
      this.props;

    if (navigator.onLine) {
      showLoador({ loador: true });
      await getClaimBalanceAndHistory({
        monthYear: dayjs().format("MM-YYYY"),
      }).then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }

  }

  onSearchList = (data) => {
    const { getClaimBalanceAndHistory, showLoador, showNotification } =
      this.props;
    if (navigator.onLine) {


      showLoador({ loador: true });
      getClaimBalanceAndHistory({
        monthYear: data.month,
      }).then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  rowViewData = (rowData) => {
    const { getClaimDetailsForDayEndBeats, showLoador, showNotification } =
      this.props;

    this.setState({
      fixedCalculation: rowData.fixedCalculation && rowData.fixedCalculation,
    });

    const beatAllowanceTypes =
      JSON.parse(localStorage.getItem("isShowBeatAllowanceTypesNames")) || {};

    let isTaDaClaimAmountEditable = localStorage.getItem("isTaDaClaimAmountEditable") &&
      localStorage.getItem("isTaDaClaimAmountEditable") == 1 ? true : false;

    let beatType1 = beatAllowanceTypes?.beatType1 || "-";
    let beatType2 = beatAllowanceTypes?.beatType2 || "-";

    if (rowData.fixedCalculation && rowData.fixedCalculation == 1) {
      showLoador({ loador: true });
      apiGet({
        url: endpoint.beat + "/claim-details-for-day-end-beats-with-edited-data?date="
          + rowData.date + "&salesTeamId=" + rowData.salesTeam,
      }).then(({ data, success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error", });
        } else {

          let dataList = data.data.beatWorkInfo.map((dataObj, index) => {
            return {
              index: index + 1,
              beatName: dataObj.beatName !== null ? dataObj.beatName : "-",
              beatType: dataObj.beatType !== null ? (dataObj.beatType == 0 ?
                beatType1 : beatType2) : "-",
              travelAllowanceAmt:
                data.data.isEdited == 1 ?
                  dataObj.travelAllowance !== null ? dataObj.travelAllowance.editedClaimAmt.toFixed(2) : "-" :
                  dataObj.travelAllowance !== null ? dataObj.travelAllowance.amt.toFixed(2) : "-",
              dailyAllowanceAmt:
                data.data.isEdited == 1 ?
                  dataObj.dailyAllowance !== null ? dataObj.dailyAllowance.editedClaimAmt.toFixed(2) : "-" :
                  dataObj.dailyAllowance !== null ? dataObj.dailyAllowance.amt.toFixed(2) : "-",
              total:
                data.data.isEdited == 1 ?
                  dataObj.totalEditedClaimAmt !== null ? dataObj.totalEditedClaimAmt.toFixed(2) : "-" :
                  dataObj.total !== null ? dataObj.total.toFixed(2) : "-",
            }
          });
          this.setState({
            DataToSet: [
              {
                xs: 12,
                sm: 4,
                md: 4,
                lg: 4,
                label: "Date",
                value: rowData.date !== null ? rowData.date : "",
              },
              {
                xs: 12,
                sm: 4,
                md: 4,
                lg: 4,
                label: "Claim Status",
                value:
                  data.data.claimStatus !== null
                    ? data.data.claimStatus == 0
                      ? "Pending for approval"
                      : data.data.claimStatus == 1
                        ? "Cancelled"
                        : data.data.claimStatus == 2
                          ? "Approved"
                          : "Rejected"
                    : "",
              },
              {
                xs: 12,
                sm: 4,
                md: 4,
                lg: 4,
                label: "Claim Amount",
                value: data.data.finalTotal !== null ? data.data.finalTotal.toFixed(2) : "",
              },
            ],
            viewPopup: true,
            dataList,
          });
        }
      });
    } else {
      let viewDataList = [];
      let claimApplyDetails = [];
      showLoador({ loador: true });
      apiGet({
        url: endpoint.claimApplyHeader + "/" + rowData.id,
      }).then(({ data, success }) => {
        showLoador({ loador: false });
        if (success) {
          claimApplyDetails = data.data.claimApplyDetails.map(
            (dataObj, index) => {
              let dataJson = {
                index: index + 1,
                date: dataObj.date !== null ? dataObj.date : "",
                claimType:
                  dataObj.claimType !== null && dataObj.claimType.name !== null
                    ? dataObj.claimType.name
                    : "",
                claimAmt:
                  dataObj.claimAmt !== null ? dataObj.claimAmt.toFixed(2) : "",
                remark: dataObj.remark !== null && dataObj.remark !== "" ? dataObj.remark : "-",
                attachmentStatus: dataObj.attachFile !== null ? "1" : "0",
                attachFile:
                  dataObj.attachFile !== null ? dataObj.attachFile : "",
              };
              return dataJson;
            }
          );
          viewDataList.push(data.data);
          this.setState({
            DataToSet: [
              {
                xs: 12,
                sm: 4,
                md: 4,
                lg: 4,
                label: "Date",
                value: data.data.date !== null ? data.data.date : "-",
              },
              {
                xs: 12,
                sm: 4,
                md: 4,
                lg: 4,
                label: "Claim Title",
                value: data.data.name !== null ? data.data.name : "-",
              },
              {
                xs: 12,
                sm: 4,
                md: 4,
                lg: 4,
                label: "Claim Amount",
                value: data.data.claimAmt !== null ? data.data.claimAmt.toFixed(2) : "-",
              },
            ],
            claimApplyDetails: claimApplyDetails,
            viewPopup: true,
          });
        }
      });
    }
  };

  handleClosesCategory = () => {
    this.setState({
      viewPopup: false,
    });
  };

  rowCancel = (rowData) => {
    const { showLoador, showNotification, getClaimBalanceAndHistory } =
      this.props;

    if (rowData.status !== "Pending") {
      showNotification({
        msg: "Only claims with status 'Pending' can be deleted.",
        severity: "warning",
      });
      return;
    }

    swal({
      title: "Are you sure?",
      text: cancelClaim,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        showLoador({ loador: true });

        const statusCode = 1;

        apiGet({
          url:
            endpoint.claimApplyHeader +
            "/update-status?claimApplyHeaderId=" +
            rowData.id +
            "&status=" +
            statusCode,
        }).then(({ data, success }) => {
          if (!success) {
            showLoador({ loador: false });
            showNotification({
              msg: serverMsg,
              severity: "error",
            });
          } else {
            showNotification({ msg: statusmsg });
            this.getData();
          }
        });
      }
    });
  };

  render() {
    const { ClaimList, beatList } = this.props;
    const {
      viewPopup,
      viewData,
      DataToSet,
      fixedCalculation,
      claimApplyDetails,
      dataList,
    } = this.state;

    return (
      <>
        <Paper
          sx={{
            padding: 2,
          }}
          elevation={0}
        >
          <DynamicMainScreen
            formPath={MyClaimJson.formPath}
            screenTitle={MyClaimJson.screenTitle}
            fieldMeta={MyClaimJson.fieldMeta}
            showPdfDownload={MyClaimJson.showPdfDownload}
            showExcelDownload={false}
            showExtension={false}
            pdfFileName={MyClaimJson.pdfFileName}
            excelFileName={MyClaimJson.excelFileName}
            showAddButton={MyClaimJson.showAddButton}
            tableColumnsToFilter={MyClaimJson.tableColumnsToFilter}
            tableColumns={MyClaimColumns}
            tableData={ClaimList?.claimApplyHeaderNew}
            getTableData={this.getData}
            apiBaseURL={MyClaimJson.apiBaseURL}
            baseIdColumn={MyClaimJson.baseIdColumn}
            showDeleteIcon={false}
            showViewButtonInTable={true}
            showFilterIcon={true}
            onSearchData={this.onSearchList}
            searchList={MyClaimJson.searchList}
            rowView={this.rowViewData}
            staticView={true}
            showCancel={true}
            showCancelTitle={"Cancel Claim"}
            rowCancel={this.rowCancel}
            editConditionName="statusForTableCondition"
            editConditionValue="0"
            cancelBillConditionName="statusForTableCondition"
            cancelBillConditionValue="0"
            callApi={false}
            getTableDataById={true}
          />
        </Paper>
        {viewPopup && (
          <MyClaimViewPopUp
            open={viewPopup}
            handleCloses={this.handleClosesCategory}
            columns={
              fixedCalculation == 1
                ? [
                  {
                    title: "Sr. No.",
                    name: "index",
                    positionCenter: false,
                    showInscreen: true,
                    alignCell: "center",
                    align: "center",
                  },
                  {
                    title: "Beat Name",
                    name: "beatName",
                    positionCenter: false,
                    showInscreen: true,
                    alignCell: "left",
                    alignCenter: "left",
                    canSearch: true,
                  },
                  {
                    title: "Beat Type",
                    name: "beatType",
                    positionCenter: false,
                    showInscreen: true,
                    alignCell: "left",
                    alignCenter: "left",
                    canSearch: true,
                  },
                  {
                    title: "Travel Allowance",
                    name: "travelAllowanceAmt",
                    positionCenter: false,
                    showInscreen: true,
                    alignCell: "right",
                    alignCenter: "right",
                    canSearch: true,
                  },
                  {
                    title: "Daily Allowance",
                    name: "dailyAllowanceAmt",
                    positionCenter: false,
                    showInscreen: true,
                    alignCell: "right",
                    alignCenter: "right",
                    canSearch: true,
                  },
                  {
                    title: "Total",
                    name: "total",
                    positionCenter: false,
                    showInscreen: true,
                    alignCell: "right",
                    alignCenter: "right",
                    canSearch: true,
                  },
                ]
                : [
                  {
                    title: "Sr. No.",
                    name: "index",
                    positionCenter: false,
                    showInscreen: true,
                    alignCell: "center",
                    align: "center",
                  },
                  {
                    title: "Claim Type",
                    name: "claimType",
                    positionCenter: false,
                    showInscreen: true,
                    alignCell: "left",
                    alignCenter: "left",
                    canSearch: true,
                  },
                  {
                    title: "Amount",
                    name: "claimAmt",
                    positionCenter: false,
                    showInscreen: true,
                    alignCell: "right",
                    alignCenter: "right",
                    canSearch: true,
                  },

                  {
                    title: "Remark",
                    name: "remark",
                    positionCenter: false,
                    showInscreen: true,
                    alignCell: "left",
                    alignCenter: "left",
                    canSearch: true,
                  },
                  {
                    title: "Attachment",
                    name: "action",
                    positionCenter: false,
                    showInscreen: true,
                    alignCell: "center",
                    alignCenter: "center",
                    canSearch: true,
                  },
                ]
            }
            rows={
              fixedCalculation == 1
                ? dataList
                : claimApplyDetails
            }
            DataToSet={DataToSet}
            fixedCalculation={fixedCalculation}
          />
        )}
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  ClaimList: state.claim,
  beatList: state.beat,
});
const mapDispatchToProps = {
  getClaimBalanceAndHistory,
  getClaimDetailsForDayEndBeats,
  showLoador,
  showNotification,
};
export default connect(mapStateToProps, mapDispatchToProps)(MyClaimTable);
